<template>
    <div>
        <v-overlay :value="loading"><v-progress-circular indeterminate size="64"></v-progress-circular></v-overlay>
        
        <v-row>
            <v-col cols="12" md="8" sm="8">
                <div class="text-center">
                    <v-btn-toggle rounded v-model="toggleStatus">
                        <v-btn class="teal--text">
                            <font-awesome-icon icon="truck" class="mr-1"/>
                            <span> {{ $t('delivery_note') }}</span>
                        </v-btn>
                        <v-btn class="green--text">
                            <font-awesome-icon icon="truck-loading" class="mr-1"/>
                            <span> {{ $t('arrived') }}</span>
                        </v-btn>
                    </v-btn-toggle>
                </div>
            </v-col>

            <v-col cols="12" md="4" sm="4">
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    :label="$t('search')"
                    single-line
                    hide-details
                ></v-text-field>
            </v-col>

            <v-col cols="12">
                <div class="text-center">
                    <v-pagination
                        v-model="currentPage"
                        :length="pageCount"
                        circle
                    ></v-pagination>
                </div>
            </v-col>

            <v-col
                v-for="(deliveryDoc,ind) in transactionDeliveriesList"
                :key="ind"
                cols="12"
                md="3"
                sm="2"
            >
                <v-card>
                    <v-card-text>
                        <table>
                            <tr v-if="isOperator">
                                <td>{{ $t('client') }}</td>
                                <td> : </td>
                                <td> <h3>{{ deliveryDoc.client_name }}</h3> </td>
                            </tr>
                            <tr>
                                <td>{{ $t('supplier') }}</td>
                                <td> : </td>
                                <td> <h3>{{ deliveryDoc.supplier_name }}</h3> </td>
                            </tr>

                            <tr>
                                <td>{{ $t('phone') }}</td>
                                <td> : </td>
                                <td>{{ deliveryDoc.supplier_mobile | formatPhoneNumber }}</td>
                            </tr>

                            <tr>
                                <td>{{ $t('deliveryName') }}</td>
                                <td> : </td>
                                <td>{{ deliveryDoc.delivery_name }}</td>
                            </tr>

                            <tr>
                                <td>{{ $t('driverPhone') }}</td>
                                <td> : </td>
                                <td>{{ deliveryDoc.driver_phone | formatPhoneNumber }}</td>
                            </tr>

                            <tr>
                                <td>{{ $t('truckPlateNumber') }}</td>
                                <td> : </td>
                                <td>{{ deliveryDoc.truck_plate_number }}</td>
                            </tr>

                             <tr>
                                <td>{{ $t('po_reference') }}</td>
                                <td> : </td>
                                <td>{{ deliveryDoc.po_reference }}</td>
                            </tr>

                            <tr>
                                <td>{{ $t('dn_reference') }}</td>
                                <td> : </td>
                                <td>{{ deliveryDoc.reference }}</td>
                            </tr>

                            <tr>
                                <td>{{ $t('date') }}</td>
                                <td> : </td>
                                <td> {{ deliveryDoc.date }}</td>
                            </tr>

                            <tr>
                                <td>{{ $t('totalAmount') }}</td>
                                <td> : </td>
                                <td> <h3>{{ parseFloat(deliveryDoc.total_amount) | formatNumber }}{{getCurrencySymbol(deliveryDoc.currency_code) }} </h3></td>
                            </tr>

                        </table>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions class="pr-4 pl-4">
                        <v-spacer></v-spacer>
                        <v-btn rounded small v-if="deliveryDoc.status==='delivery_note'" color="primary" @click="handleDeliverAcceptance(deliveryDoc)">{{$t('accept')}}</v-btn>
                        <v-btn rounded small v-if="deliveryDoc.status!='delivery_note'" @click="showDetail(deliveryDoc)">{{$t('viewDetail')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="dialogDeliveryAcceptance" persistent fullscreen>
            <delivery-acceptance :delivery-doc="detailDoc" v-if="dialogDeliveryAcceptance" :is-edit="false" @handleCreateDeliveryAcceptance="handleCreateDeliveryAcceptance"></delivery-acceptance>
        </v-dialog>

        <v-dialog v-model="dialogShoDeliveryNoteDetail" v-if="dialogShoDeliveryNoteDetail" width="50%" :fullscreen="$vuetify.breakpoint.mobile">
            <delivery-note-detail :delivery-doc="detailDoc" @handleCloseDeliveryDetail="handleCloseDeliveryDetail"></delivery-note-detail>
        </v-dialog>

        <v-dialog v-model="dialogReceivePayment" persistent width="50%">
            <receive-payment :payment-doc="paymentObj" v-if="dialogReceivePayment" :is-edit="false" :type="paymentObj.client_type" @handleCloseReceivePayment="handleCloseReceivePayment"></receive-payment>
        </v-dialog>

    </div>
</template>
<script>

    import OptionDataMixin from "../../../mixins/optionDataMixin";
    import MainMixin from "../../../mixins/mainMixin";
    import ValidatorMixin from "../../../mixins/validatorMixin";
    import DeliveryAcceptance from "./deliveryAcceptance";
    import DeliveryNoteDetail from "./deliveryNoteDetail";
    import ReceivePayment from "./receivePayment";

    import {provider} from "@/service/provider";
    import axios from "axios";
    import _ from "lodash";

    export default {
        mixins: [OptionDataMixin, MainMixin, ValidatorMixin],
        components: {DeliveryAcceptance, DeliveryNoteDetail, ReceivePayment},
        data() {
            return {
                dialogReceivePayment:false,
                dialogShoDeliveryNoteDetail: false,
                search: "",
                toggleStatus: 0,
                dialogDeliveryAcceptance: false,
                detailDoc: {},
                paymentDoc: {},
                tmpStatus: "delivery_note",
                page: 1,
                paymentObj:{}
            };
        },
        methods: {
            handleConfirm(doc) {
                console.log(doc);
            },
            handleCloseDeliveryDetail() {
                this.dialogShoDeliveryNoteDetail = false;
            },
            handleCloseReceivePayment() {
                let vm = this;
                vm.dialogReceivePayment = false;
            },
            submit() {
                let vm = this;
                vm.dialog = false;
            },
            handleCreateDeliveryAcceptance(d) {
                let vm = this;
                vm.dialogDeliveryAcceptance = false;
                vm.fetchDataTable();
                if (d && d.isPayment === true) {
                    vm.getTransactionPaymentTermByTransactionId(d.transaction_id);
                }
            },


            fetchDataTable: _.debounce(function () {
                let vm = this;
                vm.fetchTransactionDeliveries({
                    search: vm.search,
                    id: "",
                    offset: vm.page,
                    limit: vm.itemsPerPage,
                    sortBy: "created_at",
                    sortDesc: 1,
                    type: "purchase_order",
                    status: vm.tmpStatus
                });
            }, 700),

            showDetail(doc){
                let vm = this;
                let url = provider.baseURL + provider.getTransactionDeliveryNote;
                return new Promise((resolve, reject) => {
                    axios.post(url, {
                        search: "",
                        id: doc.id,
                        contact_id: "",
                        offset: 0,
                        sort_by: "created_at",
                        sort_desc: 1,
                        limit: 1,
                        type: "purchase_order"
                    }, {headers: {Authorization: localStorage.token}}).then(
                        res => {
                            if (res.data.response && res.data.response.code === 200) {
                                vm.detailDoc = {};
                                resolve(res.data.data);
                                let newItem = res.data.data[0];
                                vm.detailDoc = newItem;
                                vm.detailDoc.transaction_delivery_id = newItem.id;
                                vm.$nextTick(() => {
                                    vm.dialogShoDeliveryNoteDetail = true;
                                })
                            }
                        },
                        error => {
                            reject(error);
                        }
                    );
                });
            },
            handleDeliverAcceptance(doc) {
                let vm = this;
                let url = provider.baseURL + provider.getTransactionDeliveryNote;
                return new Promise((resolve, reject) => {
                    axios.post(url, {
                        search: "",
                        id: doc.id,
                        contact_id: "",
                        offset: 0,
                        sort_by: "created_at",
                        sort_desc: 1,
                        limit: 1,
                        type: "purchase_order"
                    }, {headers: {Authorization: localStorage.token}}).then(
                        res => {
                            if (res.data.response && res.data.response.code === 200) {
                                vm.detailDoc = {};
                                resolve(res.data.data);
                                let newItem = res.data.data[0];
                                vm.detailDoc = newItem;
                                vm.detailDoc.transaction_delivery_id = newItem.id;
                                vm.$nextTick(() => {
                                    vm.dialogDeliveryAcceptance = true;
                                })
                            }
                        },
                        error => {
                            reject(error);
                        }
                    );
                });
            },
            getTransactionPaymentTermByTransactionId(id) {
                let url = provider.baseURL + provider.getDueTransactionPaymentTerm;
                let selector = {};
                selector.search = "";
                selector.transaction_id = id;
                selector.contact_id = "";
                selector.type_order = "";
                selector.offset = 0;
                selector.limit = 1;
                selector.due_date = "";
                selector.sort_by = "created_at";
                selector.sort_desc = 1;
                let vm = this;
                vm.overlay = true;
                return new Promise((resolve, reject) => {
                    axios.post(url, selector, {headers: {Authorization: localStorage.token}}).then(
                        res => {
                            if (res.data.response && res.data.response.code === 200) {
                                resolve(res.data.data[0]);
                                vm.paymentObj = res.data.data[0];
                                vm.dialogReceivePayment = true;
                            }
                            vm.overlay = false;
                        },
                        error => {
                            reject(error);
                            vm.overlay = false;

                        }
                    );
                });
            },

        },
        watch: {
            currentPage(val) {
                let vm = this;
                vm.fetchTransactionDeliveries({
                    search: vm.search,
                    offset: val,
                    id: "",
                    limit: vm.itemsPerPage,
                    sortBy: "created_at",
                    sortDesc: 1,
                    type: "purchase_order",
                    status: vm.tmpStatus
                });
            },
            toggleStatus(val) {
                let vm = this;
                vm.tmpStatus = val === 0 ? "delivery_note" : val === 1 ? 'accepted' : 'delivery_note';
                vm.fetchTransactionDeliveries({
                    search: vm.search,
                    id: "",
                    offset: vm.currentPage,
                    limit: vm.itemsPerPage,
                    sortBy: "created_at",
                    sortDesc: 1,
                    type: "purchase_order",
                    status: vm.tmpStatus
                });
            },
            search() {
                this.fetchDataTable();
            },
        },
        computed: {
            userDoc() {
                return this.$store.state.userDoc;
            }
        },
        created() {
            //let vm = this;
            //vm.fetchTransactionOrder();
            let vm = this;
            vm.itemsPerPage = 12;
            vm.fetchTransactionDeliveries({
                search: vm.search,
                id: "",
                offset: vm.page,
                limit: vm.itemsPerPage,
                sortBy: "created_at",
                sortDesc: 1,
                type: "purchase_order",
                status: "delivery_note"
            });
        }
    };
</script>
